import types from '../types'
import Action from '../../types/Action'

const initialState = {
  loading: true,
  error: false,
  success: false,
  data: []
}

const staffingModelReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.GET_STAFFING_MODEL_REQUESTED: {
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
    case types.GET_STAFFING_MODEL_FULFILLED: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload
      }
    }
    case types.GET_STAFFING_MODEL_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default staffingModelReducer